import { render, staticRenderFns } from "./NewPromotionUpload.vue?vue&type=template&id=ad7a3906&scoped=true&"
import script from "./NewPromotionUpload.vue?vue&type=script&lang=js&"
export * from "./NewPromotionUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad7a3906",
  null
  
)

export default component.exports